import { LOGOUT_SIGNAL_KEY } from '@/constants/session-keys';

// 'idle' is the involuntary sign-out — the only one that resumes the user's
// page on the next sign-in.
export type LogoutReason = 'idle' | 'user';

// Other tabs watch this key and tear their own session down when it changes.
export function broadcastLogout(reason: LogoutReason) {
  try {
    localStorage.setItem(
      LOGOUT_SIGNAL_KEY,
      JSON.stringify({ at: Date.now(), reason }),
    );
  } catch {
    // ignore storage failures — the tab that called this still logs out
  }
}

export function readLogoutReason(signal: string | null): LogoutReason {
  try {
    // A signal from a tab running an older build is a bare timestamp. Reading
    // it as deliberate keeps the safe default: no resume.
    return JSON.parse(signal ?? '')?.reason === 'idle' ? 'idle' : 'user';
  } catch {
    return 'user';
  }
}
